var map = {
	"./audience.svg": 7576,
	"./background-act-1-a.svg": 908,
	"./background-act-1-b.png": 9740,
	"./background-act-2-a.svg": 7752,
	"./background-act-2-b.png": 3480,
	"./background-act-3-a.svg": 6887,
	"./background-act-3-b.png": 6441,
	"./background-floor.svg": 1494,
	"./background-glow.png": 3508,
	"./background-presentation-1.png": 6948,
	"./background-presentation-2.svg": 9878,
	"./background-presentation-3.png": 3778,
	"./background-wall.svg": 4025,
	"./button-next.svg": 1835,
	"./button-prev.svg": 1693,
	"./button-reveal-winner.svg": 6514,
	"./cast/actors/andrea_frydenlund.svg": 4063,
	"./cast/actors/bianca_madsen.svg": 1028,
	"./cast/actors/chris_braet.svg": 2212,
	"./cast/actors/elsa_sigurdsdottir.svg": 4369,
	"./cast/actors/erasmus_holberg.svg": 6006,
	"./cast/actors/freddy_langhorn.svg": 931,
	"./cast/actors/jamilla_ghazali.svg": 6614,
	"./cast/actors/jennifer_lovloes.svg": 3199,
	"./cast/actors/john_delman.svg": 8718,
	"./cast/actors/kit_rex.svg": 6263,
	"./cast/actors/knud_k.svg": 1098,
	"./cast/actors/lene_norland.svg": 6268,
	"./cast/actors/luca_bakir.svg": 4226,
	"./cast/actors/michael_nguyen.svg": 5314,
	"./cast/actors/mohammed_badawi.svg": 3022,
	"./cast/actors/nikita_morgenstjerne.svg": 5341,
	"./cast/actors/rasmus_havebro.svg": 269,
	"./cast/actors/soeren_tal.svg": 6558,
	"./cast/actors/sofie_hejdrup.svg": 9602,
	"./cast/actors/thor_moelner.svg": 7557,
	"./cast/instructors/anders_madsen.svg": 296,
	"./cast/instructors/denice_bonbon.svg": 6414,
	"./cast/instructors/helle_kvidrum.svg": 9053,
	"./cast/instructors/jhoern_hanzennnnn.svg": 7776,
	"./cast/instructors/louise_lange.svg": 4514,
	"./cast/instructors/pauline_show.svg": 5756,
	"./cast/instructors/pelle_halsloes.svg": 3605,
	"./cast/instructors/victor_vaagen.svg": 2061,
	"./cast/scenographers/julie_lak.svg": 2887,
	"./cast/scenographers/lotte_blaamus.svg": 3269,
	"./cast/scenographers/mads_maalestok.svg": 8766,
	"./cast/scenographers/magnus_maalestok.svg": 7854,
	"./cast/scenographers/rebecca_costello.svg": 376,
	"./cast/scenographers/sorin_stiftov.svg": 141,
	"./cast/scenographers/ulla_vildsen.svg": 6846,
	"./cast/scenographers/villiam_vilje.svg": 5962,
	"./curtain-left.svg": 9559,
	"./curtain-right.svg": 8764,
	"./groups/background-show-and-people.svg": 6291,
	"./groups/background-show.svg": 4368,
	"./groups/background.svg": 4370,
	"./groups/blaa-kat.svg": 5394,
	"./groups/det-skaeve-teater.svg": 8351,
	"./groups/det-soede-teater.svg": 2596,
	"./groups/monkey-tonkey.svg": 2443,
	"./groups/skov-teatret.svg": 694,
	"./groups/teater-den-glade-ko.svg": 6164,
	"./icons/icon-cross.svg": 1146,
	"./icons/icon-download.svg": 7428,
	"./icons/icon-loading.svg": 2854,
	"./icons/icon-play.svg": 7023,
	"./icons/icon-settings.svg": 2322,
	"./icons/icon-star-filled.svg": 3463,
	"./icons/icon-star.svg": 9832,
	"./logo-ap-moller-fonden.png": 4573,
	"./logo-cgl.svg": 6839,
	"./logo-dansk-teater.svg": 9404,
	"./logo-teater-centrum.png": 2037,
	"./menu-bullet-white.svg": 7572,
	"./menu-bullet-yellow.svg": 3634,
	"./radial.png": 8595,
	"./speech-bubble-left.svg": 9562,
	"./speech-bubble-right.svg": 6215,
	"./title-culture.svg": 5453,
	"./title-logo.svg": 2139,
	"./title-theatre.svg": 2919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;